/** @jsx jsx */
import { Button, ButtonComponentProps } from "@eworkit/iris";
import React, { FC } from "react";
import { jsx } from "theme-ui";

interface BannerButtonProps extends ButtonComponentProps {
  as: React.ElementType;
  to: string;
}

export const BannerButton: FC<BannerButtonProps> = ({ ...buttonProps }) => {
  return (
    <Button
      variant="ghost"
      size="lg"
      sx={{
        backgroundColor: "n0",
        color: "n1000",
        border: "none",
        ":not([aria-disabled='true']):hover": {
          color: "n1000",
        },
      }}
      {...buttonProps}
    />
  );
};
